import { sessionCache } from '../storage';
/** 缓存统一前缀，写入方*/
export const CACHE_KEY_PREFIX = 'WPHK_ACT_BASE';
/** 重定向次数记录key */
export const REDIRECT_TAG = `${CACHE_KEY_PREFIX}#LOGIN_TIMES`;
/** 最近一次重定向时间 */
export const CACHE_TIME = `${CACHE_KEY_PREFIX}#LOGIN_CACHE_TIME`;
/**
 * 判断是否达到了最大重定向次数（如果最近一次重定向在1min以上，则清理次数）
 * @param max
 * @returns
 */
export function isRedirectMax(max = 3) {
    // 最近一次重定向时间大于1min，则清空次数
    const cacheTime = sessionCache.getItem(CACHE_TIME);
    if (new Date().getTime() - parseInt(cacheTime, 10) > 1 * 60 * 1000) {
        sessionCache.removeItem(REDIRECT_TAG);
    }
    const redirectTag = sessionCache.getItem(REDIRECT_TAG);
    return redirectTag > max;
}
/**
 * 记录重定向次数
 */
export function addRedirectTimes() {
    // 重定向次数
    let redirectTime = sessionCache.getItem(REDIRECT_TAG) || 0;
    // 重定向次数累加1
    redirectTime = redirectTime + 1;
    sessionCache.setItem(REDIRECT_TAG, redirectTime);
    // 记录当前重定向时间
    sessionCache.setItem(CACHE_TIME, new Date().getTime());
}
